<template>
  <abk-message-form :submitAction="updateMessage" :messageId="messageId"/>
</template>

<script>
import AbkMessageForm from '../../components/messages/AbkMessageForm'
import ApiMessages from '../../api/messages'

export default {
  name: 'MessagesEdit',
  components: { AbkMessageForm },
  data () {
    return {
      messageId: this.$route.params.id
    }
  },
  methods: {
    updateMessage (message) {
      return ApiMessages.updateMessage(this.messageId, message)
    },
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.messages.messages_new.title'),
        subtitle: this.$t('views.messages.messages_new.subtitle')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>
